import { render, staticRenderFns } from "./AppSectionEntity.vue?vue&type=template&id=5a576fb0&"
import script from "./AppSectionEntity.vue?vue&type=script&lang=js&"
export * from "./AppSectionEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports